<template>
  <TaskCardDetail
    :task="task"
    :selected="selected"
    show-checkbox
    navigation-mode="route"
    :checklist-id="checklistId"
    :tasklist-view="tasklistView"
    data-testid="horizon-task-card"
    @selection-change="$emit('selection-change', $event)"
  />
</template>

<script>
import TaskCardDetail from '@/modules/financialclose/components/TaskCardDetail/TaskCardDetail.vue';
import { HORIZON_VIEWS } from '../../../utils/horizonConstants';

/** Horizon wrapper — reuses shared TaskCardDetail with checkbox + route navigation. */
export default {
  name: 'HorizonTaskCardDetail',

  components: {
    TaskCardDetail,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    checklistId() {
      return this.$route.params.id;
    },
    tasklistView() {
      return HORIZON_VIEWS.HORIZON;
    },
  },
};
</script>
